import {connect} from 'react-redux';
import axios from 'axios';
import store from "../../../../redux/store";
import SplashScreen111 from '../SplashScreen';
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import * as NavigationService from "../../../../redux/NavigationService";
import {typeExport} from "../../../../redux/store/type";
import {addAllFormData} from "../../../../tools/Tools1";

const mapStateToProps = (state) => ({
    results_City: state.reducerSplashGetAllData.results_City,
    results: state.reducerSplashGetAllData.results,
    NoInternetDialog: state.reducerSplashGetAllData.NoInternetDialog,
    isLoading: state.reducerSplashGetAllData.isLoading,


    NoInternetDialogShahrdar: state.reducerSplashGetAllData.NoInternetDialogShahrdar,
    isLoadingShahrdar: state.reducerSplashGetAllData.isLoadingShahrdar,
    resultsShahrdar: state.reducerSplashGetAllData.resultsShahrdar,

    NoInternetDialog125: state.reducerSplashGetAllData.NoInternetDialog125,
    isLoading125: state.reducerSplashGetAllData.isLoading125,
    results125: state.reducerSplashGetAllData.results125,


    isLoadingSaina: false,
    resultsSaina: state.reducerSplashGetAllData.resultsSaina,
    NoInternetDialogSaina: state.reducerSplashGetAllData.NoInternetDialogSaina,
    showDialohCity: state.reducerSplashGetAllData.showDialohCity,
    error: state.reducerSplashGetAllData.error,
    user: state.reducerSplashGetAllData.user,
    token: state.reducerSplashGetAllData.token,
    tokenMahaleh: state.reducerSplashGetAllData.tokenMahaleh,
    tokenLaravel: state.reducerSplashGetAllData.tokenLaravel,
    idCity: state.reducerSplashGetAllData.idCity,
    StoreName: state.reducerSplashGetAllData.StoreName,
    Rtl: state.reducerSplashGetAllData.Rtl,
    Lang: state.reducerSplashGetAllData.Lang,
    token_fb: state.reducerSplashGetAllData.token_fb,
    Background: state.reducerSplashGetAllData.Background,
    STATE: state.reducerSplashGetAllData.STATE,
    Connection: state.reducerSplashGetAllData.Connection,
    Location: state.reducerSplashGetAllData.Location,
    CenterLocation: state.reducerSplashGetAllData.CenterLocation,
    TypeLogin: state.reducerSplashGetAllData.TypeLogin,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token, token_fb, imageBackground, RequestElse) => dispatch(callWebservice(url, params, type, typeConnection, token, token_fb, imageBackground, RequestElse)),
    callServiceSuccess: (data, token, user) => dispatch(serviceActionSuccess(data, token, user)),
    callServiceSuccessSaina: (data, token, user) => dispatch(serviceActionSuccessSaina(data, token, user)),
    callServiceSuccessSahrdar: (data, token, user) => dispatch(serviceActionSuccessShahrdar(data, token, user)),
    callServiceSuccess125: (data, token, user) => dispatch(serviceActionSuccess125(data, token, user)),
    callServiceSetTypeLogin: (data, token, user) => dispatch(serviceActionSetTypeLogin(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetTokenMahaleh: (token) => dispatch(serviceActionSetTokenMahaleh(token)),
    callServiceSetTokenLaravel: (token) => dispatch(serviceActionSetTokenLaravel(token)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),
    callServiceSetIdCity: (data) => dispatch(serviceActionSetIdCity(data)),
    callServiceAddCart: (data, methd) => dispatch(serviceActionAddCart(data, methd)),
    callServiceSubCart: (data) => dispatch(serviceActionSubCart(data)),
    callServiceRtl: (data) => dispatch(serviceActionRtl(data)),
    callServiceLang: (data) => dispatch(serviceActionLang(data)),
    callServiceBackground: (data) => dispatch(serviceActionBackground(data)),
    callServiceChangeNotifUser: (data) => dispatch(serviceActionChangeNotifUser(data)),
    callServiceTokenFirebase: (data) => dispatch(serviceActionTokenFirebase(data)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceError: (data) => dispatch(serviceActionError(data)),
    callServiceSetLocation: (data) => dispatch(serviceActionSetLocation(data)),
    callServiceSetCenterLocation: (data) => dispatch(serviceActionSetCenterLocation(data)),
    callServiceListNotSendMyApply: (data, index) => dispatch(serviceActionListNotSendMyApply(data, index)),
    //setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),
})

const getOperation = (type) => {
    switch (type) {
        case typeExport.TypeGetAllDataSaina:
            return typeExport._Registration;
        case typeExport.TypeGetAllData:
            return typeExport._Registration;

        case typeExport.TypeGetAllDataShardar:
            return typeExport._Shahrdar;
        case typeExport.TypeGetAllData125:
            return typeExport._Fire;
    }
}
const getMode = (type) => {
    switch (type) {
        case typeExport.TypeGetAllDataSaina:
            return typeExport._GetSubjects;
        case typeExport.TypeGetAllData:
            return typeExport._GetSubjects;

        case typeExport.TypeGetAllDataShardar:
            return typeExport._GetMenuShahrdar;
        case typeExport.TypeGetAllData125:
            return typeExport._GetInfo;
    }
}
const getDataDisatch = (dispatch, url, params, type, typeConnection, token, token_fb, imageBackground, RequestElse) => {


    /* var CancelToken = axios.CancelToken;
     let source = CancelToken.source();
     setTimeout(() => {
         source.cancel();
     }, 300);
     return axios.get(ip + '/config', {cancelToken: source.token}).then((result) => {
         // My logic
     })*/

    // if (!RequestElse)
    switch (type) {

        case typeExport.TypeGetAllDataSaina:
            dispatch(serviceActionPendingSaina());
            break;
        case typeExport.TypeGetAllData:
            dispatch(serviceActionPending());
            break;

        case typeExport.TypeGetAllDataShardar:
            dispatch(serviceActionPendingShahrdar());
            break;
        case typeExport.TypeGetAllData125:
            dispatch(serviceActionPending125());
            break;

        default:
    }
    //  else {
    dispatch(serviceActionPendingBackground(true));
    dispatch(serviceActionErrorBackground(false));
    //  }

    let checkType = type == typeExport.TypeGetAllDataShardar;
    let formData = new FormData();
    // formData.append('_operation', checkType ? typeExport._Shahrdar : typeExport._Registration);
    // formData.append('mode', checkType ? typeExport._GetMenuShahrdar : typeExport._GetSubjects);
    formData.append('_operation', getOperation(type));
    formData.append('mode', getMode(type));
    formData.append('token_fb', params.token_fb);
    formData.append('device', global._Device ? global._Device.value : null);
    formData.append('token_mahale', params.token_mahale);
    formData.append('tokenLaravel', params.tokenLaravel);
    addAllFormData(formData);

    checkType ?
        formData.append('_session', params.token == null ? '' : params.token)
        :
        formData.append('token', params.token == null ? '' : params.token);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        },
        timeout: typeExport._TIMEOUT,
    };


    switch (type) {

        case typeExport.TypeGetAllDataSaina:
            axios.post(url, formData, config)
                .then(async response => {
                    let data = response.data;
                    if (data.success) {

                        dispatch(serviceActionSuccessSaina(data));

                        let user = data.result.user;
                        if (user && user.token && user.token.length > 0) {
                            // alert("jvjkchv")

                            dispatch(serviceActionSetToken(data.result.user.token));
                            dispatch(serviceActionSetUser(data.result.user));
                            await AsyngStorageClass.setAsyng(typeExport._USER, data.result.user);

                        } else {

                            await AsyngStorageClass.removeToken();
                            // await AsyngStorageClass.setAsyng("token", null);
                            //
                            // dispatch(serviceActionSetToken(null));
                        }
                        if (!RequestElse)
                            dispatch(serviceActionPending());
                        if (typeExport._NameApp != "MahalemaArak") {
                            dispatch(callWebservice(typeExport.urlGetAllData, params, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBackground, RequestElse))

                        }
                        else {

                            if (!(user && user.token && user.token.length > 0)) {
                                NavigationService.resetTo('LoginStackScreen')
                            }

                        }

                    } else {
                        dispatch(serviceActionPendingBackground(false));
                        dispatch(serviceActionErrorBackground(true));

                        await AsyngStorageClass.removeToken();
                        //if (!RequestElse)
                        dispatch(serviceActionErrorSaina("e"));
                    }


                    // if(response.status==200){
                    //     if (!RequestElse)
                    //         dispatch(serviceActionPending());
                    //     dispatch(callWebservice(typeExport.urlGetAllData, params, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBackground, RequestElse))
                    //
                    // }
                }).catch((e) => {
                dispatch(serviceActionPendingBackground(false));
                dispatch(serviceActionErrorBackground(true));

                console.log(e)
                //if (!RequestElse)
                dispatch(serviceActionErrorSaina(e));

            })
            break;
        case typeExport.TypeGetAllData:
            axios(
                {
                    // url: baseUrl + url + params,
                    url: typeExport.baseUrlWP + url,
                    method: typeConnection,
                    params: params,
                    timeout: typeExport._TIMEOUT,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        // "Authorization": token,
                    },
                    /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
                }
            )
                .then(async response => {

                    let data = response.data;

                    if (data.status) {


                        dispatch(serviceActionSuccess(data));
                        dispatch(serviceActionTokenFirebase(params.token_fb));
                        dispatch(serviceActionBackground(imageBackground));

                        if (RequestElse != undefined && data.menus) {
                            let dataSplash = store.getState().reducerSplashGetAllData
                            await AsyngStorageClass.setAsyng("splash" + global.IdCity, data);
                            if (dataSplash.resultsSaina?.success) {
                                await AsyngStorageClass.setAsyng("splashSaina" + global.IdCity, dataSplash.resultsSaina);
                            }
                        }

                        if (!RequestElse){
                           // alert("aaaa")
                            NavigationService.resetTo('DrawerScreen')

                        }


                        dispatch(serviceActionPendingBackground(false));

                    }
                    else {
                        dispatch(serviceActionPendingBackground(false));
                        dispatch(serviceActionErrorBackground(true));

                        //  if (!RequestElse)
                        dispatch(serviceActionError("e"));
                    }

                }).catch((e) => {
                console.log(e)
                dispatch(serviceActionPendingBackground(false));
                dispatch(serviceActionErrorBackground(true));

                //   if (!RequestElse)
                dispatch(serviceActionError(e))

            })
            break;

        case typeExport.TypeGetAllDataShardar:
            axios.post(url, formData, config)
                .then(async response => {
                    let data = response.data;

                    if (data.success) {
                        global.list_menu_shahrdar = data.result.menu
                        dispatch(serviceActionSuccessShahrdar(data));
                        await AsyngStorageClass.setAsyng("splashShahrdar" + global.IdCity, data);
                        if (data.result.user && data.result.user.session.length > 0) {
                            dispatch(serviceActionSetToken(data.result.user.session));
                            dispatch(serviceActionSetUser(data.result.user));
                            await AsyngStorageClass.setAsyng(typeExport._USER, data.result.user);


                        } else {
                            //  dispatch(serviceActionSetToken(null));
                            dispatch(serviceActionSetToken(token));
                        }
                        // if (!RequestElse)
                        //     NavigationService.navigatereset('DrawerScreen')
                    } else {

                        if (data.error && (data.error.code == 1501 || data.error.code == 1210 || data.error.code == 1412 || data.error.code == 1414)) {
                            global.ErrorLogin = true
                            AsyngStorageClass.removeToken();
                            //NavigationService.navigatereset("LoginStack")
                        }

                        else
                            dispatch(serviceActionErrorShahrdar("e", response));
                    }
                    if (typeExport._NameApp != "MahalemaArak")
                        dispatch(callWebservice(typeExport.urlGetAllData, params, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBackground, RequestElse))
                    else {
                        if (global.ErrorLogin) {
                            NavigationService.resetTo('LoginStackScreen')
                        }
                        else {
                            if (!RequestElse)
                                NavigationService.resetTo('DrawerScreen')
                        }

                    }

                }).catch((e) => {
                if (!RequestElse)
                    dispatch(serviceActionErrorShahrdar(e));

            })
            break;
        case typeExport.TypeGetAllData125:
            axios.post(url, formData, config)
                .then(async response => {
                    let data = response.data;

                    if (data.success) {
                        // global.list_menu_125 = data.result.menu
                        dispatch(serviceActionSuccess125(data));
                        //await AsyngStorageClass.setAsyng("splash125" + global.IdCity, data);
                        if (data.result.user && data.result.user.token && data.result.user.token.length > 0) {
                            dispatch(serviceActionSetToken(data.result.user.token));
                            dispatch(serviceActionSetUser(data.result.user));
                            await AsyngStorageClass.setAsyng(typeExport._USER, data.result.user);
                            //     NavigationService.navigatereset('Drawer125')
                            NavigationService.resetTo('DrawerScreen')

                        } else {
                            //  dispatch(serviceActionSetToken(null));
                            //dispatch(serviceActionSetToken(token));
                            AsyngStorageClass.removeToken();
                            NavigationService.resetTo('LoginStackScreen')

                            //    NavigationService.navigatereset('LoginStack')
                        }
                        /* if (!RequestElse)
                             NavigationService.navigatereset('DrawerStack125')*/
                    } else {

                        if (data.error && (data.error.code == 1501 || data.error.code == 1210 || data.error.code == 1412 || data.error.code == 1414)) {
                            global.ErrorLogin = true
                            AsyngStorageClass.removeToken();
                            // NavigationService.navigatereset("LoginStack")
                            NavigationService.resetTo('LoginStackScreen')


                        }

                        else
                            dispatch(serviceActionError125("e", response));
                    }
                }).catch((e) => {
                console.log(e)
                if (!RequestElse)
                    dispatch(serviceActionError125(e));

            })
            break;

        default:
            dispatch(serviceActionErrorShahrdar('not exit :  ' + type));
    }

    //
    // if (type === typeExport.TypeGetAllDataSaina) {
    //     axios.post(url, formData, config)
    //         .then(async response => {
    //             let data = response.data;
    //             switch (type) {
    //
    //                 case typeExport.TypeGetAllDataSaina:
    //
    //                     if (data.success) {
    //                         dispatch(serviceActionSuccessSaina(data));
    //                         if (data.result.user && data.result.user.token.length > 0) {
    //                             dispatch(serviceActionSetToken(data.result.user.token));
    //                             dispatch(serviceActionSetUser(data.result.user));
    //                             await AsyngStorageClass.setAsyng(typeExport._USER, data.result.user);
    //
    //                         } else {
    //                             dispatch(serviceActionSetToken(null));
    //                         }
    //                         if (!RequestElse)
    //                             dispatch(serviceActionPending());
    //                         dispatch(callWebservice(typeExport.urlGetAllData, params, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBackground, RequestElse))
    //
    //                     } else {
    //                         global.MyVar = ':)';
    //                         //   dispatch(serviceActionSetToken(null));
    //                         //  dispatch(callWebservice(urlGetAllData, params, TypeGetAllData, _GET, token, token_fb, imageBackground, RequestElse))
    //                         if (!RequestElse)
    //                             dispatch(serviceActionErrorSaina("e"));
    //                     }
    //
    //
    //                     /*                        dispatch(serviceActionPending());
    //                                             dispatch(callWebservice(urlGetAllData, params, TypeGetAllData, _GET, token, token_fb, imageBackground, RequestElse))*/
    //                     break;
    //                 case typeExport.TypeGetAllData:
    //                     if (response.data.status) {
    //                         if (!RequestElse) {
    //                             let dataSplash = store.getState().reducerSplashGetAllData
    //
    //                             await AsyngStorageClass.setAsyng("splash"+global.IdCity, data);
    //
    //                             await AsyngStorageClass.setAsyng("splashSaina"+global.IdCity, dataSplash.resultsSaina);
    //                         }
    //                         //dispatch(serviceActionSetWallet(2222, 2));
    //                         dispatch(serviceActionSuccess(data));
    //                         dispatch(serviceActionTokenFirebase(params.token_fb));
    //                         dispatch(serviceActionBackground(imageBackground));
    //
    //                     }
    //                     else {
    //                         if (!RequestElse)
    //                             dispatch(serviceActionError("e"));
    //                     }
    //                     break;
    //
    //                 default:
    //             }
    //         }).catch((e) => {
    //         if (!RequestElse)
    //             switch (type) {
    //
    //                 case typeExport.TypeGetAllDataSaina:
    //                     dispatch(serviceActionErrorSaina(e));
    //                     break;
    //                 case typeExport.TypeGetAllData:
    //                     dispatch(serviceActionError(e))
    //                     break;
    //
    //                 default:
    //             }
    //     })
    // } else {
    //     axios(
    //         {
    //             // url: baseUrl + url + params,
    //             url: typeExport.baseUrlWP + url,
    //             method: typeConnection,
    //             params: params,
    //             timeout: typeExport._TIMEOUT,
    //             headers: {
    //                 'Content-Type': 'application/x-www-form-urlencoded',
    //                 // "Authorization": token,
    //             },
    //             /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
    //         }
    //     )
    //         .then(async response => {
    //             let data = data;
    //             switch (type) {
    //
    //                 case typeExport.TypeGetAllDataSaina:
    //
    //                     dispatch(serviceActionSuccessSaina(data));
    //                     if (!RequestElse)
    //                         dispatch(serviceActionPending());
    //                     dispatch(callWebservice(typeExport.urlGetAllData, params, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBackground, RequestElse))
    //
    //                     break;
    //                 case typeExport.TypeGetAllData:
    //                     if (data.status) {
    //
    //
    //                         dispatch(serviceActionSuccess(data));
    //                         dispatch(serviceActionTokenFirebase(params.token_fb));
    //                         dispatch(serviceActionBackground(imageBackground));
    //
    //                         if (RequestElse != undefined && data.menus) {
    //                             let dataSplash = store.getState().reducerSplashGetAllData
    //                             await AsyngStorageClass.setAsyng("splash"+global.IdCity, data);
    //                             if (dataSplash.resultsSaina.success) {
    //                                 await AsyngStorageClass.setAsyng("splashSaina"+global.IdCity, dataSplash.resultsSaina);
    //                             }
    //                         }
    //
    //
    //                     }
    //                     else {
    //                         if (!RequestElse)
    //                             dispatch(serviceActionError("e"));
    //                     }
    //                     break;
    //
    //                 default:
    //             }
    //
    //         }).catch((e) => {
    //         if (!RequestElse)
    //             switch (type) {
    //
    //                 case typeExport.TypeGetAllDataSaina:
    //                     dispatch(serviceActionErrorSaina(e));
    //                     break;
    //                 case typeExport.TypeGetAllData:
    //                     dispatch(serviceActionError(e))
    //                     break;
    //
    //                 default:
    //             }
    //     })
    // }
    //

}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token, token_fb, imageBackground, RequestElse) => {
    return dispatch => {


        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        /*     NetInfo.isConnected.fetch().then(isConnected => {

                 if (isConnected) {*/
        getDataDisatch(dispatch, url, params, type, typeConnection, token, token_fb, imageBackground, RequestElse);
        /*     } else {
                 switch (type) {
                     case TypeGetCityData:
                         dispatch(serviceActionError("no connect"));
                         break;
                     case TypeGetAllData:
                         dispatch(serviceActionError("no connect"));
                 }
             }
         });*/
        //    }

        /*  NetInfo.getConnectionInfo().done(
              (isConnected) => {
                  if (isConnected) {
                      getDataDisatch(dispatch, url, params, type, typeConnection, token, token_fb, imageBackground, RequestElse);
                  }
                  else {
                      switch (type) {
                          case TypeGetCityData:
                              dispatch(serviceActionError("no connect"));
                              break;
                          case TypeGetAllData:
                              dispatch(serviceActionError("no connect"));
                      }
                  }
              }
          )*/

    }
}

export const serviceActionErrorBackground = (data) => ({
    type: typeExport.SPLASH_SERVICE_ERROR_Background,
    NoInternetDialogBackground: data,

})
export const serviceActionPendingBackground = (data) => ({
    type: typeExport.SPLASH_SERVICE_PENDING_Background,
    isLoadingBackground: data,

})
export const serviceActionPending = () => ({
    type: typeExport.SPLASH_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    error: false,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.SPLASH_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.SPLASH_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    /*  token: token,
      user: user,*/
    isLoading: false,
})
export const serviceActionPendingSaina = () => ({
    type: typeExport.SPLASH_SERVICE_PENDING_Saina,
    NoInternetDialogSaina: false,
    isLoadingSaina: true,
    error: false,

})

export const serviceActionErrorSaina = (error) => ({
    type: typeExport.SPLASH_SERVICE_ERROR_Saina,
    NoInternetDialogSaina: true,
    error: error,
    isLoadingSaina: false,

})

export const serviceActionSuccessSaina  = (data) => ({
    type: typeExport.SPLASH_SERVICE_SUCCESS_Saina,
    NoInternetDialogSaina: false,
    resultsSaina: data,
    /*    token: token,
        user: user,*/
    isLoadingSaina: false,
})
export const serviceActionPendingShahrdar = () => ({
    type: typeExport.SPLASH_SERVICE_PENDING_Shahrdar,
    NoInternetDialogShahrdar: false,
    isLoadingShahrdar: true,
    error: false,

})

export const serviceActionErrorShahrdar = (error) => ({
    type: typeExport.SPLASH_SERVICE_ERROR_Shahrdar,
    NoInternetDialogShahrdar: true,
    error: error,
    isLoadingShahrdar: false,

})
export const serviceActionSuccessShahrdar = (data) => ({
    type: typeExport.SPLASH_SERVICE_SUCCESS_Shahrdar,
    NoInternetDialogShahrdar: false,
    resultsShahrdar: data,
    /*    token: token,
        user: user,*/
    isLoadingShahrdar: false,
})
export const serviceActionPending125 = () => ({
    type: typeExport.SPLASH_SERVICE_PENDING_125,
    NoInternetDialog125: false,
    isLoading125: true,
    error: false,

})

export const serviceActionError125 = (error) => ({
    type: typeExport.SPLASH_SERVICE_ERROR_125,
    NoInternetDialog125: true,
    error: error,
    isLoading125: false,

})
export const serviceActionSuccess125 = (data) => ({
    type: typeExport.SPLASH_SERVICE_SUCCESS_125,
    NoInternetDialog125: false,
    results125: data,
    /*    token: token,
        user: user,*/
    isLoading125: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.SPLASH_SERVICE_REFRESH,
    NoInternetDialog: false,
    error: false,
    isLoading: false,
    results: null,

    results125: null,
    NoInternetDialog125: false,
    isLoading125: false,

    resultsShahrdar: null,
    NoInternetDialogShahrdar: false,
    isLoadingShahrdar: false,

    resultsSaina: null,
    NoInternetDialogSaina: false,
    isLoadingSaina: false,
})


export const serviceActionPendingCity = () => ({
    type: typeExport.SPLASH_SERVICE_PENDING_CITY,
    NoInternetDialogCity: false,
    isLoadingCity: true,
    error: false,
    showDialohCity: false

})

export const serviceActionErrorCity_CITY = (error) => ({
    type: typeExport.SPLASH_SERVICE_ERROR_CITY,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccessGetCityData = (data) => ({
    type: typeExport.SPLASH_SUCCESS_GET_CITY_DATA,
    NoInternetDialog: false,
    results_City: data,
    showDialohCity: true,
    isLoading: false,
})
export const serviceActionSetToken = (token) => ({
    type: typeExport.SPLASH_TOKEN,
    token: token,
})
export const serviceActionSetTokenMahaleh = (token) => ({
    type: typeExport.SPLASH_TOKEN_MAHALEH,
    token: token,
})
export const serviceActionSetTokenLaravel = (token) => ({
    type: typeExport.SPLASH_TOKEN_LARAVEL,
    token: token,
})
export const serviceActionSetUser = (user) => ({
    type: typeExport.SPLASH_USER,
    user: user,
})
export const serviceActionSetWallet = (data, typeWallet) => ({
    type: typeExport.SPLASH_WALLET,
    wallet: data,
    typeWallet: typeWallet,
})


export const serviceActionSetIdCity = (data) => ({
    type: typeExport.SPLASH_CITY,
    idCity: data,
})
export const serviceActionAddCart = (data, methd) => ({
    type: typeExport.SERVICE_ADD_CART,
    product: data,
    methd: methd,
})
export const serviceActionSubCart = (data) => ({
    type: typeExport.SERVICE_SUB_CART,
    product: data,
})
export const serviceActionPriceAll = () => ({
    type: typeExport.SERVICE_PRICE_ALL,
})
export const serviceActionClearAllCart = () => ({
    type: typeExport.SERVICE_CLEAR_ALL_CART,
})

export const serviceActionChangeItemDiscount = () => ({
    type: typeExport.SERVICE_CHANGE_ITEM_DISCOUNT_FIRST,
})
export const serviceActionRestaurantBasketCheck = (data) => ({
    type: typeExport.SERVICE_RestaurantBasketCheck,
    data: data,
})
export const serviceActionRtl = (data) => ({
    type: typeExport.SERVICE_Rtl,
    data: data,
})

export const serviceActionLang = (data) => ({
    type: typeExport.SERVICE_Lang,
    data: data,
})
export const serviceActionBackground = (data) => ({
    type: typeExport.SERVICE_Background,
    data: data,
})

export const serviceActionChangeNotifUser = (data) => ({
    type: typeExport.SERVICE_ChangeNotifUser,
    data: data,
})
export const serviceActionTokenFirebase = (data) => ({
    type: typeExport.SERVICE_TokenFirebase,
    data: data,
})

export const serviceActionSetState = (data) => ({
    type: typeExport.SERVICE_STATE,
    STATE: data,
})

export const serviceActionSetIsConnected = (data) => ({
    type: typeExport.SERVICE_Connection,

    Connection: data,
})
export const serviceActionSetConnectionType = (data) => ({
    type: typeExport.SERVICE_ConnectionType,

    ConnectionType: data,
})
export const serviceActionSetLocation = (data) => ({
    type: typeExport.SERVICE_Location,

    Location: data,
})
export const serviceActionSetCenterLocation = (data) => ({
    type: typeExport.SERVICE_CenterLocation,

    Location: data,
})
export const serviceActionSetTypeLogin = (data) => ({
    type: typeExport.SERVICE_TypeLogin,

    TypeLogin: data,
})
export const serviceActionListNotSendMyApply = (data, index) => ({
    type: typeExport.SERVICE_ListNotSendMyApply,

    ListNotSendMyApply: data,
    indexListNotSendMyApply: index,
})
export const serviceActionNotSendListOperatorApply = (data, index) => ({
    type: typeExport.SERVICE_NotSendListOperatorApply,


    NotSendListOperatorApply: data,
    indexNotSendListOperatorApply: index,
})
export const serviceActionListNotSendRegisterComplaints = (data, index) => ({
    type: typeExport.SERVICE_ListNotSendRegisterComplaints,

    ListNotSendRegisterComplaints: data,
    indexListNotSendRegisterComplaints: index,
})
export const serviceActionSetNameDynamic = (name, data) => ({
    type: typeExport.SERVICE_NameDynamic,

    name: name,
    data: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen111);
